import ROUTES from 'Utilities/routes';

export const isMakeAndModelChange = (route: string, asPath: string): boolean => {
	const routeWithoutSearchParams = route.split('?')[0];

	if (
		routeWithoutSearchParams.includes(ROUTES.INSIGHTS_LANDING.as()) &&
		routeWithoutSearchParams !== ROUTES.INSIGHTS_LANDING.as()
	) {
		const pathWithoutSearchParams = asPath.split('?')[0];

		return routeWithoutSearchParams !== pathWithoutSearchParams;
	}

	return false;
};
